import React from "react";
import DatePicker from "react-datepicker";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function InputFieldControl(props) {
  const { localization } = useLanguageContext();
  const {
    name,
    type,
    dropDownList,
    selectedValue,
    _onchange,
    _index,
    _className,
    label,
    _onDateChange,
    isLabel,
    minDate,
    startDate,
    isDisable = false,
  } = props;

  const handleInputChange = (_value) => {
    _onchange(_value, _index, name);
  };

  const handleDateChange = (value) => {
    _onDateChange(value, _index, name);
  };

  const renderInputField = () => {
    if (type === "int" || type === "float") {
      return (
        <input
          className="form-control"
          type="number"
          onChange={(e) => {
            handleInputChange(parseInt(e.target.value));
            e.preventDefault();
          }}
          id={name + _index}
          name={name}
          value={selectedValue}
        />
      );
    } else if (type === "string") {
      return (
        <input
          className="form-control"
          type="text"
          onChange={(e) => {
            handleInputChange(e.target.value);
            e.preventDefault();
          }}
          value={selectedValue}
        />
      );
    } else if (type === "bool") {
      return (
        <select
          className="form-control"
          onChange={(e) => {
            //  e.preventDefault();
            handleInputChange(e.target.value);
            e.preventDefault();
          }}
          value={selectedValue}
        >
          <option value="">Select</option>
          <option value="true">{localization.trueValue}</option>
          <option value="false">{localization.falseValue}</option>
        </select>
      );
    } else if (type === "dropDown") {
      return (
        <select
          className="form-control"
          onChange={(e) => {
            //   e.preventDefault();
            handleInputChange(e.target.value);
            e.preventDefault();
          }}
          value={selectedValue}
        >
          {dropDownList.map((value, index) => (
            <option key={index} value={value}>
              {value}
            </option>
          ))}
        </select>
      );
    } else if (type === "datePicker" || type === "datetime") {
      return (
        <DatePicker
          disabled={isDisable}
          className="form-control w-100"
          // selected={new Date("04.19.2024")}
          value={selectedValue}
          minDate={startDate}
          //  showMonthDropdown={true}
          //   showYearDropdown={true}
          onChange={(date) => {
            handleDateChange(date);
            // handleDate(date, counter, rowitem.name);
          }}
          dateFormat="dd-MM-yyyy"
          //   placeholderText={rowitem.name}
        />
        // <input
        //   className="form-control"
        //   type="text"
        //   onChange={handleInputChange}
        // />
      );
    } else {
      return null;
    }
  };

  if (isLabel) {
    return (
      <div className={`form-group ${_className}`} key={_index}>
        <label htmlFor={name}>{label}</label>
        {renderInputField()}
      </div>
    );
  } else {
    return renderInputField();
  }
}
